import {useMutation, useQuery} from '@apollo/client/react';

import {graphql} from '../gqlApp';

graphql(`
	fragment MeFields on Me {
		id
		phone
		phoneVerified
		firstName
		lastName
		name
		email
		accountType
		createdAt
	}
`);

export const GET_ME = graphql(`
	query Me {
		me {
			...MeFields
		}
	}
`);

/** options нужны RequireAuth: без токена запрос пропускается, а не падает с UNAUTHORIZED. */
export const useMe = (options?: {skip?: boolean}) => useQuery(GET_ME, options);

/**
 * Профиль (SKS-257): те же поля плюс hasPassword. Отдельный документ, а не поле
 * в GET_ME: за hasPassword бэкенд ходит в БД, а GET_ME шапка запрашивает на
 * каждой странице — платить за это должен только профиль.
 */
export const GET_MY_PROFILE = graphql(`
	query MyProfile {
		me {
			...MeFields
			hasPassword
			pendingEmail
		}
	}
`);

export const useMyProfile = () => useQuery(GET_MY_PROFILE);

export const GET_MY_SESSIONS = graphql(`
	query MySessions {
		mySessions {
			isCurrent
			ip
			userAgent
			createdAt
			lastSeenAt
		}
	}
`);

export const useMySessions = () => useQuery(GET_MY_SESSIONS);

export const GET_MY_LOGIN_HISTORY = graphql(`
	query MyLoginHistory {
		myLoginHistory {
			id
			event
			ip
			userAgent
			occurredAt
		}
	}
`);

export const useMyLoginHistory = () => useQuery(GET_MY_LOGIN_HISTORY);

/**
 * Ответ — Me с тем же id, поэтому Apollo сам обновит и шапку, и профиль.
 * История перечитывается: правка пишется в журнал, и ей место в списке сразу.
 */
export const UPDATE_PROFILE = graphql(`
	mutation UpdateProfile($input: UpdateProfileInput!) {
		updateProfile(input: $input) {
			...MeFields
			hasPassword
		}
	}
`);

export const useUpdateProfile = () =>
	useMutation(UPDATE_PROFILE, {refetchQueries: [GET_MY_LOGIN_HISTORY]});

/**
 * После смены пароля перечитываем всё: hasPassword мог стать true, остальные
 * сессии погашены, в истории новая запись.
 */
export const CHANGE_PASSWORD = graphql(`
	mutation ChangePassword($input: ChangePasswordInput!) {
		changePassword(input: $input)
	}
`);

export const useChangePassword = () =>
	useMutation(CHANGE_PASSWORD, {
		refetchQueries: [GET_MY_PROFILE, GET_MY_SESSIONS, GET_MY_LOGIN_HISTORY],
	});

export const REVOKE_OTHER_SESSIONS = graphql(`
	mutation RevokeOtherSessions {
		revokeOtherSessions
	}
`);

export const useRevokeOtherSessions = () =>
	useMutation(REVOKE_OTHER_SESSIONS, {
		refetchQueries: [GET_MY_SESSIONS, GET_MY_LOGIN_HISTORY],
	});

/**
 * Запрос смены почты (SKS-260): на новый адрес уходит письмо, прежний работает до
 * подтверждения. Профиль перечитываем — появляется «ожидает подтверждения».
 */
export const REQUEST_EMAIL_CHANGE = graphql(`
	mutation RequestEmailChange($input: RequestEmailChangeInput!) {
		requestEmailChange(input: $input)
	}
`);

export const useRequestEmailChange = () =>
	useMutation(REQUEST_EMAIL_CHANGE, {refetchQueries: [GET_MY_PROFILE]});

/** Повторная отправка письма смены почты (SKS-260). */
export const RESEND_EMAIL_CHANGE = graphql(`
	mutation ResendEmailChange {
		resendEmailChange
	}
`);

export const useResendEmailChange = () => useMutation(RESEND_EMAIL_CHANGE);

/**
 * Подтверждение почты по ссылке из письма (SKS-260). Публичная мутация: страница
 * /confirm-email открывается по ссылке, возможно без входа. При регистрации ответ
 * несёт токен сессии — человек входит сразу.
 */
export const CONFIRM_EMAIL = graphql(`
	mutation ConfirmEmail($input: ConfirmEmailInput!) {
		confirmEmail(input: $input) {
			status
			token
		}
	}
`);

export const useConfirmEmail = () => useMutation(CONFIRM_EMAIL);
